window.angular.module('hippoComponents').directive('mhButton', function () {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            label: '@',
            fieldId: '@',
            click: '&',
            color: '@'
        },
        template: `
    <button class="mh-button {{color}}" data-ng-click="handleClickEvent()">
      {{label}}
    </button>
    `,
        link: function (scope, $element, $attr) {
            const { componentHandler } = window;
            if (scope.fieldId) {
                $element[0].setAttribute('id', scope.fieldId);
            }
            if (componentHandler) {
                componentHandler.upgradeElements($element[0]);
            }

            $attr.$observe('disabled', function (val) {
                if (val === true || val === 'true') {
                    $element.attr('disabled', 'disabled');
                } else {
                    $element.attr('disabled', null);
                }
            });
            scope.handleClickEvent = () => {
                setTimeout(scope.click, 70);
            };
        }
    };
});
